import { BreadcrumbProps } from './index';
import { component } from './component';
import { ComponentBlock } from '@types';
import { types } from 'core/types';

export const block: ComponentBlock<'breadcrumb', BreadcrumbProps, unknown> = {
  id: 'breadcrumb',
  render: component,
  props: {
    size: {
      type: types.string,
    },
  },
};
